import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import useSeasonsFlow from '../../../../../hooks/ui_hooks/useSeasonsFlow';
import { COSTSUMMARY_TOOLTIP } from '../../../../../utilities/constants';
import { Box, Flex, Text, Tooltip } from '../../../../ui-kit';
import QuestionIcon from '../../../../ui-kit/icons/Question';
import theme from '../../../../ui-kit/themes/theme';
import { SummaryContent } from '../../Content';
import * as COPY from '../utilities/copy';

const propTypes = {
  taxes: PropTypes.number,
  sustainabilityFee: PropTypes.number,
  parkingFee: PropTypes.number,
  resortFee: PropTypes.number
};

export const AdditionalCharges = ({ taxes, sustainabilityFee, parkingFee, resortFee, lodgeOperaCode }) => {
  const { isSeasonsFlow } = useSeasonsFlow();
  const isExtraLargeScreen = useMediaQuery({
    minWidth: theme.breakpoints.xl
  });
  if (isSeasonsFlow) {
    taxes = taxes - (sustainabilityFee + parkingFee + resortFee);
  }
  const sustainabilityToolTip = ['SCOTAZ'];
  return (
    <>
      <SummaryContent.Item fontWeight="bold">
        <SummaryContent.Description style={{ fontSize: '12px' }}>{COPY.ADDITIONAL_CHARGES}</SummaryContent.Description>
      </SummaryContent.Item>
      <SummaryContent.Item>
        <SummaryContent.Description>{COPY.TAXES}</SummaryContent.Description>
        <SummaryContent.Amount>{`$${taxes.toFixed(2)}`}</SummaryContent.Amount>
      </SummaryContent.Item>
      {sustainabilityFee > 0 ? (
        <SummaryContent.Item>
          <SummaryContent.Description>
            {COPY.SUSTAINABILITY_FEE}
            {sustainabilityToolTip.includes(lodgeOperaCode) ? (
              <Flex height={16} ml={2}>
                <Tooltip
                  ariaKey="Sustainability"
                  title={COPY.SUSTAINABILITY_FEE}
                  tooltipWidth={!isExtraLargeScreen ? 200 : 300}
                  borderColor={theme.colors.snowMountainGrey[100]}
                  textAlign="left"
                  alignment={isExtraLargeScreen ? 'center' : 'right'}
                  triggerComponent={props => (
                    <Box ref={props.triggerRef}>
                      <QuestionIcon size={16} />
                    </Box>
                  )}
                  tooltipContent={() => <Text fontSize={0}>{COSTSUMMARY_TOOLTIP.sustainabilityFee}</Text>}
                />
              </Flex>
            ) : null}
          </SummaryContent.Description>
          <SummaryContent.Amount>{`$${sustainabilityFee.toFixed(2)}`}</SummaryContent.Amount>
        </SummaryContent.Item>
      ) : null}

      {parkingFee > 0 ? (
        <SummaryContent.Item>
          <SummaryContent.Description>{COPY.PARKING_FEE}</SummaryContent.Description>
          <SummaryContent.Amount>{`$${parkingFee.toFixed(2)}`}</SummaryContent.Amount>
        </SummaryContent.Item>
      ) : null}
      {resortFee > 0 && !isSeasonsFlow ? (
        <SummaryContent.Item>
          <SummaryContent.Description>
            {COPY.AMENITY_FEE}
            <Flex height={16} ml={2}>
              <Tooltip
                ariaKey="Amenity Fee"
                title={COPY.AMENITY_FEE}
                tooltipWidth={!isExtraLargeScreen ? 250 : 300}
                borderColor={theme.colors.snowMountainGrey[100]}
                textAlign="left"
                alignment={isExtraLargeScreen ? 'center' : 'right'}
                triggerComponent={props => (
                  <Box ref={props.triggerRef}>
                    <QuestionIcon size={16} />
                  </Box>
                )}
                tooltipContent={() => <Text fontSize={0}>{COPY.TOOLTIP_COPY}</Text>}
              />
            </Flex>
          </SummaryContent.Description>
          <SummaryContent.Amount>{`$${resortFee.toFixed(2)}`}</SummaryContent.Amount>
        </SummaryContent.Item>
      ) : null}
      <SummaryContent.Divider />
    </>
  );
};

AdditionalCharges.propTypes = propTypes;

AdditionalCharges.defaultProps = {
  taxes: 0,
  sustainabilityFee: 0,
  parkingFee: 0,
  resortFee: 0
};
